type RoomOwnerRef = { _id?: string; id?: string } | null | undefined

export type RoomWithManageFlag = {
  canManage?: boolean
  owner?: RoomOwnerRef
}

/** True when the user may edit room settings / see owner controls in the dashboard. */
export function canManageRoom(
  room: RoomWithManageFlag | null | undefined,
  userId: string | undefined,
): boolean {
  if (!room || !userId) return false
  if (room.canManage) return true
  const ownerId = room.owner?._id || room.owner?.id
  return Boolean(ownerId && ownerId === userId)
}
